module.exports = __webpack_public_path__ + "img/icon-reg-view-event.f9b4bf49.png";